//Function to check if the user permission
export const checkUserPermission = (permissionCode, permissions) => {
    if (!Array.isArray(permissions)) {
        return -1
    }
    let permition = permissions.map(element => element.code).indexOf(permissionCode);
    return permition
}